import { Vector } from "p5";
import { PenPath } from "./PenPathUtility";
import { THREE_INST } from "./Three/threeSingleton";

type CanvasSizeType = { width: number, height: number }

class Pen {
  p: any;
  canvasSize: CanvasSizeType = { width: 0,height: 0 }
  grower: number;
  penStartTime: number;
  // Vectors
  location: Vector;
  velocity: any;
  three: THREE_INST;

  initShrink = 1500;
  growthMax = 2000;
  shrinkMin = 0;
  speed = 0.035;


  constructor(p: any) {
    this.p = p;
    this.location = p.createVector(this.p.mouseX, this.p.mouseY);
    this.grower = 0;
    this.three = THREE_INST.getInst();
    this.penStartTime = 0;
  }

  updateCanvasSize( canvasSize : CanvasSizeType ) {
    this.canvasSize = canvasSize;
    // set shrink and grow property
    this.initShrink = Math.min( canvasSize.height, canvasSize.width ) 
    this.growthMax  = Math.max( canvasSize.height, canvasSize.width ) 

  }

  easeInExpo(t: number, b: number, c: number, d: number) {
    return t == 0 ? b : c * Math.pow(2, 10 * (t / d - 1)) + b;
  }
  easeOutQuad(t: number, b: number, c: number, d: number) {
    t /= d;
    t--;
    return c*(t*t*t*t*t + 1) + b;
  }
  easeInOutQiadeaseInOutQuint(t: number, b: number, c: number, d: number) {
      t /= d/2;
      if (t < 1) return c/2*t*t*t*t*t + b;
      t -= 2;
      return c/2*(t*t*t*t*t + 2) + b;
  }
  
  easeInOutExpo(t: number, b: number, c: number, d: number) {
    t /= d/2;
    if (t < 1) return c/2 * Math.pow( 2, 10 * (t - 1) ) + b;
    t--;
    return c/2 * ( -Math.pow( 2, -10 * t) + 2 ) + b;
  };

  grow(speed: number) {
    if (this.p.mouseIsPressed) {
      this.grower += this.speed;
    } else {
      if (this.grower == 0) {
        return;
      }
      this.grower = 0;
      return;
    }
    const ease = this.easeInExpo(this.grower, 0, 5000, speed);
    this.three.obj.setBrushSize(ease);
    if (ease > this.growthMax) {
      this.grower = 0;
    }
  }

  shrink(speed: number) {
    var changeInTime: number;
    if (this.p.mouseIsPressed) {
      if( this.penStartTime == 0 ) {
        this.penStartTime = ( new Date() ).getTime()
      }
    } else {
      this.penStartTime = 0;
      return;
    } 
    changeInTime =  ( new Date() ).getTime() - this.penStartTime;
    const ease = this.initShrink - this.easeInOutQiadeaseInOutQuint(changeInTime, 0, this.initShrink, speed * 1000 );
    this.three.obj.setBrushSize(ease);
    if ( ease <= 0 ) {
      this.penStartTime = 0;
    }
  }

  calcPath(
    path: number,
    theta: number,
    speed: number,
    radius: number,
    mX: number,
    mY: number
  ) {
    if (path === 0) {
      return this.p.createVector(mX, mY);
    }
    const angle = ((Math.PI * theta) / 400) * speed;
    const length = PenPath(path, radius, angle);
    const loc = [length * Math.cos(angle) + mX, length * Math.sin(angle) + mY];
    return this.p.createVector(loc[0], loc[1]);
  }
}

export default Pen;
